// extracted by mini-css-extract-plugin
export default {"signUpPage":"SignUpPage_signUpPage__YtsW6"};